import React from 'react';
import TagManager from 'react-gtm-module';
import StoreProvider from './StoreProvider';
import { AppRouter } from '../routes';
import Header from '../components/atoms/header';
import '../components/_settings/_base.scss';

TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });

const App = () => {
  return (
    <StoreProvider>
      <Header />
      <AppRouter />
      <div data-nossa-loader-standalone className="nossa-container" />
    </StoreProvider>
  );
};

export default App;
